import React, { useMemo } from "react";
import { useWebsite } from "../../../Context/WebSiteContext";

const HeroModern = ({ config }) => {
  const { formData } = useWebsite();

  const mergedConfig = useMemo(
    () => ({
      ...config,
      ...formData,
    }),
    [config, formData]
  );

  const header = mergedConfig.header || {};
  const bgColor = mergedConfig.primaryColor
    ? `#${mergedConfig.primaryColor}`
    : "#2196f3";
  const textColor = mergedConfig.primaryColor
    ? `#${mergedConfig.primaryColor}`
    : "#fff";
  const textColor2 = mergedConfig.secondaryColor
    ? `#${mergedConfig.secondaryColor}`
    : "#fff";

  const bgImage = header.imagemFundo ? `url(${header.imagemFundo})` : "none";

  return (
    <section
      className="w-100"
      style={{
        height: "100vh",
        width: "100%",
        background:
          bgImage !== "none"
            ? `url(${header.imagemFundo}) no-repeat right 80% bottom/cover`
            : bgColor,
        color: textColor,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "8rem 2rem 2rem 2rem",
        position: "relative",
        overflow: "hidden",
        backgroundPosition: "right 80% bottom",
      }}
    >
      {/* Gradiente sobre a imagem */}
      {bgImage !== "none" && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />
      )}
      <div
        style={{
          width: "100%",
          zIndex: 2,
          marginLeft: "2vw",
          marginTop: "-2rem",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(2.2rem, 7vw, 5rem)",
            fontWeight: 800,
            maxWidth: 700,
            marginBottom: 20,
            color: "#fff",
            lineHeight: 1.08,
            fontFamily: "'Montserrat', 'Segoe UI', Arial, sans-serif",
            letterSpacing: "-2px",
          }}
        >
          {header.nome || "Seu Empreendimento"}
        </h1>
      </div>
      <div
        className="d-flex flex-row text-center align-items-center justify-content-around gap-3 w-75 mx-auto"
        style={{
          position: "absolute",
          bottom: "20px",
          left: 0,
          right: 0,
          zIndex: 2,
          padding: "0 2rem",
        }}
      >
        <h3
          style={{
            fontSize: 28,
            color: "#fff",
            marginBottom: 28,
            maxWidth: "30%",
            fontFamily: "'Inter', Arial, sans-serif",
            fontWeight: 400,
            lineHeight: 1.5,
          }}
        >
          {header.descricao || "Descrição do empreendimento..."}
        </h3>
        <h3
          style={{
            fontSize: 28,
            color: "#fff",
            marginBottom: 28,
            maxWidth: "30%",
            fontFamily: "'Inter', Arial, sans-serif",
            fontWeight: 400,
            lineHeight: 1.5,
          }}
        >
          {header.descricao2 || "Descrição do empreendimento..."}
        </h3>
        <h3
          style={{
            fontSize: 28,
            color: "#fff",
            marginBottom: 28,
            maxWidth: "30%",
            fontFamily: "'Inter', Arial, sans-serif",
            fontWeight: 400,
            lineHeight: 1.5,
          }}
        >
          {header.descricao3 || "Descrição do empreendimento..."}
        </h3>
      </div>
    </section>
  );
};

export default HeroModern;
